export default __webpack_public_path__ + "static/media/FIDC.bdd7ec68.svg";